/* ============================================================
   Custom Size Validation for Merinos Shoes
   Disables Add to Cart until the user ACTIVELY selects a size.
   Works with or without the "SELECT-A-SIZE" workaround variant.
   Built for Impulse 9.0.0 by IT-Geeks. (v4 — permanent fix)
   ============================================================ */

(function () {
  'use strict';

  if (!document.body.classList.contains('template-product')) return;

  var PLACEHOLDER_LABEL = 'Select a Size';
  var PLACEHOLDER_VALUE = '__placeholder_select_a_size__';
  var PLACEHOLDER_VARIANTS = ['select a size', 'select size', 'choose size', 'choose a size'];
  var MESSAGE_TEXT = 'Please select a size';

  function isPlaceholder(value) {
    if (value === null || value === undefined) return true;
    var v = String(value).trim().toLowerCase();
    if (v === '' || v === PLACEHOLDER_VALUE.toLowerCase()) return true;
    return PLACEHOLDER_VARIANTS.indexOf(v) !== -1;
  }

  function init(form) {
    if (!form || form.dataset.sizeValidationInit === 'true') return;

    var formId = form.id;
    var sizeSelect = null;
    var sizeRadios = [];

    if (formId) {
      sizeSelect = document.querySelector('select[data-variant-input][form="' + formId + '"]');
      sizeRadios = document.querySelectorAll('input[type="radio"][data-variant-input][form="' + formId + '"]');
    }

    if (!sizeSelect && sizeRadios.length === 0) {
      sizeSelect = document.querySelector('select[data-variant-input]');
      sizeRadios = document.querySelectorAll('input[type="radio"][data-variant-input]');
    }

    if (!sizeSelect && sizeRadios.length === 0) return;

    var atcButton = form.querySelector('button[type="submit"], button[name="add"]');
    if (!atcButton) return;

    form.dataset.sizeValidationInit = 'true';

    // Track whether the user has actively interacted with the size selector
    var userHasPicked = false;

    // ---- Inject placeholder option if it's a <select> ----
    if (sizeSelect) {
      var hasPlaceholderAlready = false;
      for (var i = 0; i < sizeSelect.options.length; i++) {
        if (isPlaceholder(sizeSelect.options[i].value) || isPlaceholder(sizeSelect.options[i].text)) {
          hasPlaceholderAlready = true;
          // Force-select existing placeholder
          sizeSelect.selectedIndex = i;
          break;
        }
      }

      if (!hasPlaceholderAlready) {
        // Create a new placeholder and put it at the top
        var placeholderOpt = document.createElement('option');
        placeholderOpt.value = PLACEHOLDER_VALUE;
        placeholderOpt.textContent = PLACEHOLDER_LABEL;
        placeholderOpt.setAttribute('data-injected-placeholder', 'true');
        sizeSelect.insertBefore(placeholderOpt, sizeSelect.firstChild);
        sizeSelect.selectedIndex = 0;
      }
    }

    // ---- Insert the prompt message ----
    var msg = form.querySelector('.custom-size-prompt');
    if (!msg) {
      msg = document.createElement('div');
      msg.className = 'custom-size-prompt';
      msg.setAttribute('role', 'status');
      msg.textContent = MESSAGE_TEXT;
      atcButton.parentNode.insertBefore(msg, atcButton);
    }

    function getCurrentSizeValue() {
      var checkedRadio = document.querySelector('input[type="radio"][data-variant-input]:checked');
      if (checkedRadio) return checkedRadio.value;
      if (sizeSelect) return sizeSelect.value;
      return '';
    }

    function isSizeValid() {
      // Must have a real value AND user must have actively picked
      var currentValue = getCurrentSizeValue();
      if (isPlaceholder(currentValue)) return false;
      if (!userHasPicked) return false;
      return true;
    }

    function updateState() {
      if (isSizeValid()) {
        atcButton.removeAttribute('disabled');
        atcButton.classList.remove('is-size-locked');
        msg.classList.remove('is-visible');
      } else {
        atcButton.setAttribute('disabled', 'disabled');
        atcButton.classList.add('is-size-locked');
        msg.classList.add('is-visible');
      }
    }

    function forcePlaceholderSelected() {
      if (sizeSelect && !userHasPicked) {
        // Find and force-select the placeholder
        for (var i = 0; i < sizeSelect.options.length; i++) {
          if (isPlaceholder(sizeSelect.options[i].value) || isPlaceholder(sizeSelect.options[i].text)) {
            if (sizeSelect.selectedIndex !== i) {
              sizeSelect.selectedIndex = i;
            }
            break;
          }
        }
      }
    }

    // ---- Listen for user interaction on the size selector ----
    if (sizeSelect) {
      sizeSelect.addEventListener('change', function () {
        var v = sizeSelect.value;
        if (!isPlaceholder(v)) {
          userHasPicked = true;
        } else {
          userHasPicked = false;
        }
        setTimeout(updateState, 30);
      });
    }

    sizeRadios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (!isPlaceholder(radio.value)) {
          userHasPicked = true;
        }
        setTimeout(updateState, 30);
      });
    });

    // Listen on the form (fallback)
    form.addEventListener('change', function () {
      setTimeout(updateState, 50);
    });

    // Listen for theme variant change events
    document.addEventListener('variant:change', function () {
      setTimeout(function () {
        // If theme is overriding our placeholder back to a real size, fight back
        if (!userHasPicked) forcePlaceholderSelected();
        updateState();
      }, 30);
    });

    // ---- Block form submission ----
    form.addEventListener('submit', function (e) {
      if (!isSizeValid()) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        msg.classList.add('is-visible', 'is-shake');
        setTimeout(function () { msg.classList.remove('is-shake'); }, 600);
        return false;
      }
    }, true);

    // ---- Block button click as final safety net ----
    atcButton.addEventListener('click', function (e) {
      if (!isSizeValid()) {
        e.preventDefault();
        e.stopPropagation();
        msg.classList.add('is-visible', 'is-shake');
        setTimeout(function () { msg.classList.remove('is-shake'); }, 600);
        return false;
      }
    }, true);

    // ---- Initial state ----
    updateState();

    // Re-run repeatedly to fight theme JS auto-selecting
    setTimeout(function () { forcePlaceholderSelected(); updateState(); }, 100);
    setTimeout(function () { forcePlaceholderSelected(); updateState(); }, 400);
    setTimeout(function () { forcePlaceholderSelected(); updateState(); }, 1000);
    setTimeout(function () { forcePlaceholderSelected(); updateState(); }, 2000);
  }

  function findAndInit() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    forms.forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', findAndInit);
  } else {
    findAndInit();
  }

  var observer = new MutationObserver(function () {
    findAndInit();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();